export default {
  name: 'scopeMixin',
  computed: {
    isKengen() {
      return this.$store.getters.isKengen;
    },
    isGoalOrientedProgram() {
      return this.$store.getters.isGoalOrientedProgram;
    },
    isSequentialProgram() {
      return this.$store.getters.isSequentialProgram;
    },
    isSelfMentorshipProgram() {
      return this.$store.getters.isSelfMentorshipProgram;
    },
    isArchivedProgram() {
      return this.$store.getters.isArchivedProgram;
    },
  },

  methods: {
    assertProgram(programId, redirect = false) {
      const currentProgramId = this.$store.state.user.programid;

      // eslint-disable-next-line eqeqeq
      if (currentProgramId != programId) {
        if (redirect) {
          this.$router.push({ name: 'app' });
        }

        return false;
      }

      return true;
    },
  },
};
